<template>
  <CreateEditRoleModal
    v-if="showCreateEditRoleModal"
    :roleId="roleId"
    @closeModal="closeCreateEditRoleModal"
  />
  <DeleteRoleModal
    v-if="showDeleteRoleModal"
    :roleId="roleId"
    @closeModal="closeDeleteRoleModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Detalhes do Cargo</h6>
      <div class="ms-auto">
        <router-link
          to="/roles"
          class="btn btn-outline-dark"
          title="Listagem de Cargos"
        >
          Listagem de Cargos
        </router-link>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <p><strong>Nome:</strong> {{ role.name }}</p>
        </div>
        <div class="col-md-12 col-sm-12">
          <p><strong>Descrição:</strong> {{ role.description }}</p>
        </div>
      </div>
    </div>
    <div class="card-footer d-flex justify-content-between align-items-center">
      <ul class="list-inline text-muted mb-0">
        <li class="list-inline-item">
          Cadastrado por:
          {{ createdUpdatedUser(role.createdBy, role.createdAt) }}
        </li>
        <li class="list-inline-item">
          Atualizado por:
          {{ createdUpdatedUser(role.updatedBy, role.updatedAt) }}
        </li>
      </ul>
      <div class="w-50 text-end">
        <button
          type="button"
          class="btn btn-danger"
          title="Excluir Cargo"
          @click="showDeleteRoleModal = true"
        >
          Excluir Cargo
        </button>
        <button
          type="button"
          class="btn btn-warning ms-2"
          title="Editar Cargo"
          @click="showCreateEditRoleModal = true"
        >
          Editar Cargo
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CreateEditRoleModal from '@/components/roles/roles/CreateEditRoleModal.vue'
import DeleteRoleModal from '@/components/roles/roles/DeleteRoleModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { createdUpdatedUser } from '@/utils/strings'
import PATHS from '@/router/routesMap'

export default {
  name: 'DetailsRole',

  components: {
    CreateEditRoleModal,
    DeleteRoleModal,
    LoadingData,
  },

  props: {
    roleId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditRoleModal: false,
      showDeleteRoleModal: false,
      role: {},
      createdUpdatedUser,
    }
  },

  methods: {
    async getRole() {
      try {
        this.role = await this.$store.dispatch('getRole', this.roleId)
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$router.push(PATHS.HOME)
      }
    },

    closeCreateEditRoleModal(loadRole) {
      if (loadRole) {
        this.getRole()
      }
      this.showCreateEditRoleModal = false
    },

    closeDeleteRoleModal(excluded) {
      this.showDeleteRoleModal = false
      if (excluded) {
        this.$router.push(PATHS.ROLES)
      }
    },
  },

  mounted() {
    this.getRole()
  },
}
</script>
